import { ApolloProvider } from '@apollo/client'
import { ThemeProvider } from '@material-tailwind/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { Suspense, useEffect } from 'react'
import { RouterProvider } from 'react-router'

import ConfigureAmplify from '@/components/amplify-client'
import Fallback from '@/components/fallback'
import Notify from '@/components/notify'
import { client as apolloClient } from '@/lib/apolloClient'
import { queryClient } from '@/lib/reactQuery'
import { router } from '@/router'
import { useSetting } from '@/stores/setting'
import { mappingTheme } from '@/theme'

const App = () => {
  const mode = useSetting((state) => state.mode())

  useEffect(() => {
    if (mode === 'light') {
      document.body.classList.remove('dark')
    } else {
      document.body.classList.add('dark')
    }
  }, [mode])

  return (
    <ConfigureAmplify>
      <ApolloProvider client={apolloClient}>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider value={mappingTheme[mode]}>
            <Suspense fallback={<Fallback />}>
              <div className="min-h-screen bg-background">
                <RouterProvider router={router} />
              </div>
            </Suspense>
            <Notify />
          </ThemeProvider>
        </QueryClientProvider>
      </ApolloProvider>
    </ConfigureAmplify>
  )
}

export default App
